import { action } from 'easy-peasy';
import { IActionSetAvailableTeamMembers } from '../types';

const setAvailableActTeamMembers: IActionSetAvailableTeamMembers = action((state, payload) => {
  state.availableList = payload.sort((a, b) => (a.lastName < b.lastName ? -1 : 1));
});

export default setAvailableActTeamMembers;
